
import React from 'react'
import { compose } from 'widgets-shared/core'
import { withComponentContext } from 'widgets-shared/core'
import { withTranslations } from 'widgets-shared/core'
import { Typography, Grid } from '@mui/material'
import GSSVG from 'smartstream-widgets/controls/GSSVG'

import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { TranslationFunction } from 'smartstream-widgets/types/sharedModule/core'
import { PropTranslations } from 'smartstream-widgets/types/widget'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'

type Props = {
  classes: {
    [K in string]: string
  },
  config: {
    BASE_ASSET_PATH: string,
    tosLink: string,
    privacyPolicyLink: string
  },
  translations: PropTranslations
}

const styles = (theme: Theme) =>  createStyles({
  iconContainer: {
    padding: `0px 6px`
  },
  linkStyle: {
    textDecorationColor: theme.palette.primary.main
  },
  root: {},
  linkText: {
    fontSize: 13,
    color: theme.palette.primary.main
  },
  svgStyle: {
    fill: '#1565C0'
  },
  privacyPolicyIcon: {
    marginRight: 4,
  },
  ampersand: {
    marginLeft: 9,
    marginRight: 9,
    color: theme.palette.primary.main
  }
})

export function TermsOfService (props: Props) {
  const {
    classes,
    config,
    translations
  } = props

  const shouldShowToS = config && config.tosLink
  const shouldShowPrivacyPolicy = config && config.privacyPolicyLink

  return (
    <>
      { shouldShowToS && (
        <Grid
          container
          direction='row'
          justifyContent='flex-start'
          alignItems='center'
          className={classes.root}
        >
          <GSSVG className={classes.svgStyle} xlinkHref={`${config.BASE_ASSET_PATH}/img/icons.svg#ic-terms-service`} />
          <a className={classes.linkStyle} href={config.tosLink}
            target='_blank'>
            <Typography className={classes.linkText}>
              {translations.termsOfService}
            </Typography>
          </a>
          { shouldShowPrivacyPolicy && (
            <>
              <Typography className={classes.ampersand}>
                {translations.and}
              </Typography>
              <GSSVG className={`${classes.privacyPolicyIcon} ${classes.svgStyle}`} xlinkHref={`${config.BASE_ASSET_PATH}/img/icons.svg#ic-privacy-policy`} />
              <a className={classes.linkStyle} href={config.privacyPolicyLink} target='_blank'>
                <Typography className={classes.linkText}>
                  {translations.privacyPolicy}
                </Typography>
              </a>
            </>
            )
          }

        </Grid>
      )
    }
    </>
  )
}

export default compose(
  withComponentContext,
  withTranslations((t: TranslationFunction) => {
    return {
      termsOfService: t('termsOfService.translation', {
        defaultValue: 'Terms of Service',
        context: 'Link that redirects to Genius Sports Terms of Service page inside Odds Comparison Grid widget'
      }),
      privacyPolicy: t('privacyPolicy.translation', {
        defaultValue: 'Privacy Policy',
        context: 'Link that redirects to Genius Sports Privacy Policy page inside Odds Comparison Grid widget'
      }),
      and: t('and.translation', {
        defaultValue: ' & ',
        context: 'And text between Terms of Service and Privacy Policy inside Odds Comparison Grid widget'
      })
    }
  }),
  withStyles(styles, { name: 'TermsOfService', withTheme: true, defaultTheme: getDefaultTheme })
)(TermsOfService)
